<template>
  <div class="home-page">
    <HomeHero />
    <ServiceMatrix />
    <ProductGooval />
    <ProductInsurance />
    <ProductBlockchain />
    <ProductFinancing />
    <WhyChooseUs />
    <ContactUs />
  </div>
</template>

<script>
import HomeHero from '@/components/HomeHero.vue'
import ServiceMatrix from '@/components/ServiceMatrix.vue'
import ProductGooval from '@/components/ProductGooval.vue'
import ProductInsurance from '@/components/ProductInsurance.vue'
import ProductBlockchain from '@/components/ProductBlockchain.vue'
import ProductFinancing from '@/components/ProductFinancing.vue'
import WhyChooseUs from '@/components/WhyChooseUs.vue'
import ContactUs from '@/components/ContactUs.vue'

export default {
  name: 'HomeView',
  components: {
    HomeHero,
    ServiceMatrix,
    ProductGooval,
    ProductInsurance,
    ProductBlockchain,
    ProductFinancing,
    WhyChooseUs,
    ContactUs
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  position: relative;
  min-height: 100vh;
  background: #ffffff;
  margin: 0 auto;
}
</style>
